import { render } from "./HistorialPedidosView.vue?vue&type=template&id=67dfc719&scoped=true"
import script from "./HistorialPedidosView.vue?vue&type=script&lang=js"
export * from "./HistorialPedidosView.vue?vue&type=script&lang=js"

import "./HistorialPedidosView.vue?vue&type=style&index=0&id=67dfc719&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67dfc719"]])

export default __exports__